<script lang="ts">
	interface Props {
		tooltip?: string | null;
		name: string;
		size?: string;
	}

	let { tooltip = null, name, size = "" }: Props = $props();

	let classNames = $derived(`icon ${size}`);
	let svgHref = $derived(`#icon:${name}`);
</script>

<svg class={classNames} aria-label={tooltip ? tooltip : null}>
	<use xlink:href={svgHref} />
</svg>
